module.exports = __webpack_public_path__ + "fonts/Gilroy-MediumItalic.9bc60a85.ttf";